import { useContext } from 'react'

import { ConsultationContext, ConsultationContextProps } from '@/contexts/consultation'

interface UseLimitExceededProps {
  limitExceeded: ConsultationContextProps['limitExceeded']
  checkLimitExceeded: ConsultationContextProps['checkLimitExceeded']
}

export default function useLimitExceeded(): UseLimitExceededProps {
  const { limitExceeded, checkLimitExceeded } = useContext(ConsultationContext)

  return {
    limitExceeded,
    checkLimitExceeded
  }
}
